import React from 'react';
import styles from './ServiceAndMaintenanceSteps.module.scss';
import DoubleArrow from '../../../../Icons/DoubleArrow';
import cn from 'classnames';

const Steps = ({ steps, onClickStep }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.steps}>
        {steps.map((item, index, array) => {
          return (
            <React.Fragment key={item.id}>
              <div className={styles.step} onClick={() => onClickStep(index + 1)}>
                <div className={cn(styles.step_index, item.activeStep && styles.step_index_active)}>
                  {index + 1}
                </div>
                <p className={cn(styles.step_text, item.activeStep && styles.step_text_active)}>
                  {item.stepName}
                </p>
              </div>
              {index !== array.length - 1 && <DoubleArrow />}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default Steps;
